import { render, staticRenderFns } from "./r-treasure-level-config-table.vue?vue&type=template&id=390c7578"
import script from "./r-treasure-level-config-table.vue?vue&type=script&lang=js"
export * from "./r-treasure-level-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390c7578')) {
      api.createRecord('390c7578', component.options)
    } else {
      api.reload('390c7578', component.options)
    }
    module.hot.accept("./r-treasure-level-config-table.vue?vue&type=template&id=390c7578", function () {
      api.rerender('390c7578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-level-config-table.vue"
export default component.exports